import { isProduction, isDevelopment, currentEnv } from './env';

export const loadApiScript = (apiJsUrl, scriptId, accountid, userId) => {
	let script = document.getElementById(scriptId);
	if (script) {
		return script;
	}

	if (!apiJsUrl) {
		console.error('apiJsUrl not provided to loadApiScript');
		return;
	}

	const head = document.getElementsByTagName('head')[0] || document.documentElement;
	script = document.createElement('script');
	script.type = 'text/javascript';
	script.id = scriptId;
	script.src = apiJsUrl;
	script.async = true;
	script.dataset.account = accountid;
	script.dataset.user = userId;
	if (!isProduction()) {
		script.dataset.env = isDevelopment() ? 'dev' : currentEnv;
	}

	head.appendChild(script);

	return script;
};
